export default (route: Object, locale?: string) =>
  useLocalePath()(route, locale).replaceAll(encodeURIComponent('/'), '/')
